export enum RecipientExpansionStatus {
    None,
    InProgress,
    Failed,
    SucceededWithDLOrGroupMembers,
    SucceededWithoutDLOrGroupMembers
}

export default RecipientExpansionStatus;
